import { WatchfaceDeviceType } from '@/hooks';
import { ElectronApi } from './electron.api';

export const GlobalConfig = {
  /**
   * 图片是否使用md5
   * */
  imageMd5: true,

  /** 亮屏样式数量最大值 */
  themeCountMax: 12,

  /** 配色数量最大值 */
  themeColorMax: 16,

  /** widget内子元素最大数量 */
  widgetChildrenMaxCount: 10,

  /** widget翻译使用哪种形式 */
  // 强制使用编辑器内置的翻译，不使用协议内置
  // widgetTranslationType: 'build-in' as 'build-in' | 'follow-protocol',

  /** slot内子元素最大数量 */
  // 内部版本O61为100，其他均是50
  slotChildrenMaxCount: 50,

  /** 使用16bpp格式的设备 */
  using16bppDeviceTypes: ['N66'],

  /** 是否使用imgutils处理indexed8格式图片 */
  // 由于用imgutils生成的体积较大，暂不启用
  useImgutilsForIndexed8: false,

  /** 是否自动选择图片压缩格式 */
  autoChooseImageFormat: true,

  /** 表盘压缩 */
  adjustWatchfaceCompression: ElectronApi.isProfessional(),

  /** 序列帧图片最大数量 */
  spriteImagesMaxCount: 60,

  /** 是否验证表盘内存大小 */
  validWatchfaceRam: true,

  /** 是否验证bin文件大小 */
  validWatchfaceBin: ['M66'] as WatchfaceDeviceType[],

  // 默认表盘ID
  defaultWatchfaceId: '000000000000',

  /** 是否展示产品名称 */
  showDeviceTypeProductionName: ElectronApi.isNormal(),

  /** 组最大嵌套层级 */
  groupInletDeep: 4,

  /** 文本节点最大绑定数据源数量 */
  maxSourceCountByTextTagBind: 8,

  /** 是否是否导出缓存机制 */
  enablePngConvertCache: true,
  enablePngConvertWebWorker: true,

  // 容器是否可自定义位置
  slotPosiontEnabled: true,

  // 是否支持打开zip文件
  openZipEnabled: true,

  // 是否修改resource结构类型
  changeResourceType: false,

  // 是否支持首页直接导出表盘
  exportWatchfaceFromMainPage: ElectronApi.isDebug() || import.meta.env.DEV,

  shapeConditionMaxCount: 60,
  // 需要校验指针是否在表盘范围内的设备
  validPointerWithinRange: ['M66'] as WatchfaceDeviceType[],

  // 需要添加默认背景图
  needToAddDefaultBgImageDevices: ['M66'] as WatchfaceDeviceType[],

  // 是否需要重命名预览图
  // needRenamePreviewImage: ElectronApi.isProfessional() || import.meta.env.DEV
};
